import styled, { css } from 'styled-components';
import variables from '../../../styles/variables';
import prevArrowBlack from '../../../images/back-arrow-left-black.svg';
import nextArrowBlack from '../../../images/back-arrow-right-black.svg';

interface Props {
  readonly layout?: boolean;
  readonly selectedImg?: boolean;
}

export const ImageGallery = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  max-width: 600px;
  @media screen and (min-width: 640px) and (max-width: 768px) {
    width: 75%;
  }
`;

export const ImagesContainer = styled.div<Props>`
  display: grid;
  place-content: center;
  width: 100%;

  ${({ layout }) => layout
    ? css`
          grid-template-areas: 'thumbs image';
          grid-template-columns: auto 1fr;

          @media screen and (max-width: 640px) {
            grid-template-columns: 20% auto;
          }

          @media screen and (max-width: 480px) {
            display: none;
          }
        `
    : css`
          grid-template-areas: 'image';
          grid-template-columns: 1fr;

          @media screen and (max-width: 640px) {
            grid-template-columns: 100% auto;
          }

          @media screen and (max-width: 480px) {
            display: none;
          }
        `}
`;

export const MobileImagesContainer = styled.div`
  display: none;
  width: 100%;

  @media screen and (max-width: 480px) {
    display: block;
  }
`;

export const PrimaryImageContainer = styled.div`
  grid-area: image;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  height: 455px;
  padding: 24px;
`;

export const PrimaryImage = styled.img`
  width: 100%;
  object-fit: contain;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  img {
    object-fit: contain;
  }

  @media screen and (max-width: 480px) {
    min-height: 356px;
  }
`;

export const ThumbnailImageContainer = styled.div`
  grid-area: thumbs;
  width: 100%;
`;

export const ImageWrap = styled.button<Props>`
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  border: ${({ selectedImg }) => selectedImg ? '2px solid #000000' : '2px solid #979797'};
  border-radius: 5px;

  &:last-child {
    margin-bottom: 0;
  }
  background: transparent;
`;

export const SecondaryImage = styled.img`
  margin: 10px;
  max-height: 105px;
  width: 52px;
  @media screen and (min-width: 769px) {
    max-height: 135px;
    width: 65px;
  }
`;

export const Carousel = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;

  .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .swiper-container {
      height: auto;
    }

    .swiper-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
      margin-bottom: 3rem;

      .swiper-slide {
        height: auto;
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: flex;
        width: fit-content;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        align-self: stretch;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      height: 24px;
      width: 24px;
      border-radius: 12px;
      border: 2px solid ${variables.colorWhite};
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 30%);
      cursor: pointer;
      z-index: 11;
      transition:
        border 400ms ease,
        opacity 400ms ease;

      &.swiper-button-disabled {
        opacity: 0;
        visibility: hidden;
      }

      &:after {
        content: none;
      }

      &:hover,
      &:focus {
        border: 2px solid ${variables.colorGrey};
      }
    }

    .swiper-button-next {
      background-image: url(${nextArrowBlack});
      right: 2px;

      @media screen and (max-width: 480px) {
        right: 2px;
        top: auto;
        bottom: 10px;
      }
    }

    .swiper-button-prev {
      background-image: url(${prevArrowBlack});

      @media screen and (max-width: 480px) {
        left: 2px;
        top: auto;
        bottom: 10px;
      }
    }

    .swiper-pagination {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      bottom: 16px;
      left: 0;
      right: 0;
      width: calc(100% - 60px);
    }

    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal {
      &.swiper-pagination-bullets {
        .swiper-pagination-bullet {
            width: 10px;
            height: 10px;
            margin: 0 8px;
          }
        }
      }
    }

    .swiper-pagination-bullet-active {
      background: ${variables.colorRed};
    }

`;

export const MobileSecondaryImage = styled.img`
  max-height: 340px;
`;

export const MobileImageWrap = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: transparent;
  min-height: 356px;
`;
